import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { JobsCount } from '@fuww/library/src/List/JobList';
import { TableList } from '@fuww/library/src/List/Styled';
import { useIntl } from 'react-intl';
import LinkAndAnchor from '../../LinkAndAnchor';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages';

const jobListPropertyTypes = {
  listData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    jobsCount: PropTypes.number,
  })),
  labelKey: PropTypes.string.isRequired,
  nameKey: PropTypes.string.isRequired,
  labelHeading: PropTypes.string.isRequired,
  paramKey: PropTypes.string.isRequired,
};

type JobListProperties = Omit<
InferProps<typeof jobListPropertyTypes>, 'listData'> & {
  listData: {
    name?: string;
    slug?: string;
    jobsCount?: number;
  }[];
};

const JobList = ({
  listData,
  labelKey,
  nameKey,
  labelHeading,
  paramKey,
}: JobListProperties) => {
  const intl = useIntl();
  const { jobsLocale, jobsComplete } = useSiteContext();

  const rows = listData.map(({ name, slug, jobsCount }) => (
    [
      <LinkAndAnchor
        route={`jobs.${jobsLocale}`}
        useRouter={jobsComplete}
        params={{
          [paramKey]: slug,
        }}
        className="mdc-typography--headline5"
      >
        {intl.formatMessage(
          messages[labelKey],
          { [nameKey]: name },
        )}
      </LinkAndAnchor>,
      <JobsCount>
        {jobsCount}
      </JobsCount>,
    ]
  ));

  return (
    <TableList
      headings={[
        labelHeading,
        intl.formatMessage(messages.numberOfJobs),
      ]}
      rows={rows}
    />
  );
};

JobList.propTypes = jobListPropertyTypes;

export default JobList;
